import * as React from 'react';
import './styles/main.css';
import './styles/style.css';
var ReactDOM = require('react-dom');
import App from "./App";

const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);